import { animate, style, transition, trigger } from '@angular/animations';
import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { ShoppingCartItem } from '../../../models/shopping';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import { CartService } from '../../../services/cart.service';
import {
  extractShoppingCartItem,
  ProductAttrWithValue,
} from '../../../utils/cart';
import { ConfirmDialog } from '../../common/confirm-dialog/confirm-dialog';
import { Price } from '../../common/price/price';

@Component({
  selector: 'app-shopping-cart-list-item',
  imports: [
    FileurlPipe,
    NgOptimizedImage,
    NzInputNumberModule,
    FormsModule,
    Price,
    RouterModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './shopping-cart-list-item.html',
  styleUrl: './shopping-cart-list-item.scss',
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('250ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('250ms ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ShoppingCartListItem implements OnChanges {
  @Input({ required: true }) item!: ShoppingCartItem;

  image: string = '';
  attrs: ProductAttrWithValue[] = [];
  priced_attr?: ProductAttrWithValue;
  quantity: number = 0;
  loading: boolean = false;

  constructor(private cartService: CartService, private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update() {
    this.quantity = this.item.quantity;
    const { image, attrs, priced_attr } = extractShoppingCartItem(this.item);
    this.image = image;
    this.attrs = attrs;
    this.priced_attr = priced_attr;
  }

  onQuantityChanged() {
    if (!this.quantity) {
      return;
    }
    this.setShoppingCartItem(this.quantity);
  }

  async setShoppingCartItem(quantity: number) {
    try {
      this.loading = true;
      await this.cartService.setShoppingCartItem({
        product_id: this.item.product.id,
        quantity: quantity,
        product_attr_value_ids: this.item.product_attr_value_ids,
        product_priced_attr_value_id: this.item.product_priced_attr_value_id,
      });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  remove() {
    this.dialog
      .open(ConfirmDialog, {
        width: '420px',
        data: {
          title: 'Remove Cart Item',
          content: `Are you sure to remove <b>${this.item.product.name}</b> from cart?`,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.setShoppingCartItem(0);
        }
      });
  }
}
